import axiosInstance from "../../utils/axiosInstance";

const getCollaborations = async (params) => {
  const response = await axiosInstance.get(
    `collaboration?limit=${params.pageSize}&skip=${
      (params.current - 1) * params.pageSize
    }&key=${params.key}&status=${params.status}`
  );
  return response.data.data;
};

const getCollaboration = async (id) => {
  const response = await axiosInstance.get(`collaboration/${id}`);
  return response.data.data;
};

const createCollaboration = async (data) => {
  const response = await axiosInstance.post(`collaboration`, data);
  return response.data.data;
};

const updateCollaboration = async (params) => {
  const response = await axiosInstance.put(
    `collaboration/${params.id}`,
    params.data
  );
  return response.data.data;
};

const deleteCollaboration = async (params) => {
  const response = await axiosInstance.delete(`collaboration/${params.id}`);
  return response.data.data;
};

const updateCollaborationStatus = async (params) => {
  const response = await axiosInstance.put(
    `collaboration/${params.id}`,
    params.data
  );
  return response.data.data;
};

const collaborationService = {
  getCollaborations,
  updateCollaboration,
  createCollaboration,
  updateCollaborationStatus,
  getCollaboration,
  deleteCollaboration,
};

export default collaborationService;
